import type { Filter, FilterDataSearch } from '@/app/common/filters/core/filtersTypes';

export const FilterSearchPill = (filter: Filter): string[] => {
  const data = filter.data as FilterDataSearch;
  // FilterDataSearch does not have value or label, fallback to placeholder
  return [data.placeholder];
};
